// GENERATED from pristine constants.js — do not hand-edit.
// Regenerate: node test/tools/gen-engine-constants.js > src/engine/constants.ts
// Drift-guarded by test/engine-constants.test.js (deep-equal vs the live
// pristine tables on every run).

export const fireUpgradeInitialCosts = [ 0, 50, 100, 100, 500, 500, 20000000 ] as const

export const fireUpgradeBase = [ 0, 1.8, 2, 1.4, 1.5, 2.5, 5 ] as const

export const magicUpgradeCosts = [
 2,
 3,
 8,
 12,
 30,
 100,
 300,
 1500,
 4000,
 20000,
 100000,
 400000,
 100000000,
 300000000,
 1500000000,
 3000000000,
 100000000000,
 4000000000000,
 10000000000000,
 10000000000000000
] as const

export const darkMagicUpgradeCosts = [
 "e110",
 "e125",
 "e165",
 "e240",
 "e285",
 "e320",
 "e360",
 "e450",
 "e120000",
 "e140000",
 "e3e8",
 "e4.5e8",
 "e5e8",
 "e6e8",
 "e6.75e8",
 "e8e8",
 "e1.2e9",
 "e1.45e9",
 "e1.6e9",
 "e1.65e9"
] as const

export const voidMagicUpgradeCosts = [
 "e1.25e10",
 "e1.4e10",
 "e1.55e10",
 "e1.65e10",
 "e2e10",
 "e3e10",
 "e4e10",
 "e6.5e10",
 "e9.6e10",
 "e1.2e11",
 "e2.25e11",
 "e3.4e11",
 "e4.6e11",
 "e5.25e12",
 "e2e13",
 "e4.25e13",
 "e3.75e16"
] as const

export const knowledgeMultipliers = [ 450, 112.5, 18.75, 10, 1 ] as const

export const tomeUpgradeCosts = [ 1, 1, 2, 2, 4, 20, 75, 175, 500, 1000, 1500, 2250, 2800, 7500 ] as const

export const blueFireUpgradeInitialCosts = [ 0, 500, 1000, 50000, 50000000, 150000000, 100000000000 ] as const

export const blueFireUpgradeBase = [ 0, 1.8, 2, 2.5, 1.8, 2.2, 2 ] as const

export const holyTetrahedronUpgradeCosts = [ 1, 1, 1, 1, 2, 2, 2, 5, 5, 15, 50, 2000, 50000 ] as const

export const holyOctahedronUpgradeCosts = [ 1, 1, 1, 2, 4, 2, 50, 750, 25000 ] as const

export const holyDodecahedronUpgradeCosts = [ 1, 2, 6, 12, 1000, 150000 ] as const

export const holyFireUpgradeInitialCosts = [ 0, 500, 1000, 10000, 50000, 10000000, 1e+45 ] as const

export const holyFireUpgradeBase = [ 0, 1.8, 2, 3, 2, 2.5, 3 ] as const

export const plagueUpgradeInitialCosts = [ 0, 25, 100, 100000, 1000000, 10000000000000 ] as const

export const plagueUpgradeBase = [ 0, 2, 2.5, 3, 5, 3 ] as const

export const hypergodDefeatCosts = [
 "ee20000",
 "ee160000",
 "ee400000",
 "ee1e6",
 "ee2.4e6",
 "ee1e7",
 "ee4e7",
 "ee7e8",
 "ee2e9",
 "ee1.5e10",
 "ee1e11",
 "ee7.5e11"
] as const

export const lightEssenceUpgradeInitialCosts = [ 0, 100, 600, 3000 ] as const

export const lightEssenceUpgradeBase = [ 0, 2, 3, 3 ] as const

export const darkEssenceUpgradeInitialCosts = [ 0, 100, 1000, 10000 ] as const

export const darkEssenceUpgradeBase = [ 0, 2, 3, 3 ] as const

export const deathEssenceUpgradeInitialCosts = [ 0, 1000, 10000, 200000, 10000000, 1e+40 ] as const

export const deathEssenceUpgradeBase = [ 0, 2, 3, 3, 2.5, 4 ] as const

export const finalityEssenceUpgradeInitialCosts = [ 0, 1000, 4000, 1000000000000000, 100000000000000000000 ] as const

export const finalityEssenceUpgradeBase = [ 0, 2, 5, 4, 4 ] as const

export const nuclearPastaUpgradeCosts = [ "ee7.5e6", "ee1.2e8", "ee2.5e8", "ee7.5e8" ] as const

export const achievementRequirements = [
 [
  "100",
  "10000",
  "1e6",
  "1e12",
  "1e20",
  "1e30",
  "1e100",
  "1e250",
  "1e1000",
  "1e3000",
  "1e10000",
  "1e100000"
 ],
 [
  "1000",
  "1e6",
  "1e12",
  "1e18",
  "1e30",
  "1e100",
  "1e250",
  "1e1000",
  "1e4000",
  "1e20000",
  "1e500000",
  "e5e7"
 ],
 [
  "100",
  "100000",
  "2.5e6",
  "1e8",
  "1e12",
  "1e20",
  "1e30",
  "1e100",
  "1e250",
  "1e1000",
  "1e20000",
  "1e150000"
 ],
 [
  "1",
  "5",
  "50",
  "1000",
  "100000",
  "1e8",
  "1e20",
  "1e100",
  "1e500",
  "1e10000",
  "1e50000",
  "1e1000000"
 ],
 [
  "10000",
  "1e6",
  "1e20",
  "1e30",
  "1e50",
  "1e250",
  "1e1000",
  "1e2500",
  "1e10000",
  "1e500000",
  "1e2500000",
  "e2e7"
 ],
 [
  "100",
  "100000",
  "1e7",
  "5e8",
  "1e10",
  "1e100",
  "1e1000",
  "1e25000",
  "1e1000000",
  "e1e8",
  "e1e12",
  "e1e15"
 ],
 [
  "1",
  "5",
  "20",
  "100",
  "500",
  "1000000",
  "1e12",
  "1e25",
  "1e100",
  "1e250",
  "1e500",
  "1e1000"
 ],
 [
  "1",
  "5",
  "20",
  "100",
  "500",
  "1000000",
  "1e12",
  "1e25",
  "1e100",
  "1e250",
  "1e500",
  "1e1000"
 ],
 [
  "1",
  "5",
  "20",
  "100",
  "500",
  "1000000",
  "1e12",
  "1e25",
  "1e100",
  "1e250",
  "1e500",
  "1e1000"
 ],
 [
  "1",
  "5",
  "20",
  "100",
  "500",
  "1000000",
  "1e12",
  "1e25",
  "1e100",
  "1e250",
  "1e500",
  "1e1000"
 ],
 [
  "1",
  "5",
  "20",
  "100",
  "500",
  "1000000",
  "1e12",
  "1e25",
  "1e100",
  "1e250",
  "1e500",
  "1e1000"
 ],
 [
  "1",
  "10",
  "250",
  "10000",
  "1e9",
  "1e30",
  "1e100",
  "1e300",
  "1e750",
  "1e1500",
  "1e3000",
  "1e6000"
 ],
 [
  "1",
  "10",
  "100",
  "1000",
  "5000",
  "15000",
  "30000",
  "75000",
  "150000",
  "350000",
  "750000",
  "2.5e6"
 ],
 [
  "1000",
  "1e6",
  "1e20",
  "1e35",
  "1e60",
  "1e100",
  "1e250",
  "1e600",
  "1e1500",
  "1e3000",
  "1e20000",
  "1e100000"
 ],
 [
  "1",
  "10000",
  "5e7",
  "1e10",
  "1e20",
  "1e30",
  "1e100",
  "1e150",
  "1e200",
  "1e500",
  "1e1000",
  "1e3000"
 ],
 [
  "100",
  "10000",
  "1e6",
  "1e20",
  "1e30",
  "1e100",
  "1e500",
  "1e1000",
  "1e2500",
  "1e15000",
  "1e50000",
  "1e250000"
 ],
 [
  "1",
  "20",
  "1000",
  "100000",
  "1e8",
  "1e12",
  "1e20",
  "1e50",
  "1e150",
  "1e500",
  "1e1200",
  "1e6000"
 ],
 [
  "1",
  "20",
  "1000",
  "100000",
  "1e8",
  "1e12",
  "1e20",
  "1e50",
  "1e150",
  "1e500",
  "1e1200",
  "1e6000"
 ],
 [
  "1",
  "20",
  "1000",
  "100000",
  "1e8",
  "1e12",
  "1e20",
  "1e50",
  "1e150",
  "1e500",
  "1e1200",
  "1e6000"
 ],
 [
  "1",
  "3",
  "10",
  "50",
  "2500",
  "1000000",
  "1e9",
  "1e18",
  "1e30",
  "1e80",
  "1e250",
  "1e1000"
 ],
 [
  "1",
  "3",
  "10",
  "50",
  "2500",
  "1000000",
  "1e9",
  "1e18",
  "1e30",
  "1e80",
  "1e250",
  "1e1000"
 ],
 [
  "1000",
  "100000",
  "1e12",
  "1e20",
  "1e50",
  "1e100",
  "1e300",
  "1e1000",
  "1e5000",
  "1e20000",
  "1e100000",
  "1e500000"
 ],
 [
  "1",
  "3",
  "10",
  "50",
  "2500",
  "1000000",
  "1e9",
  "1e18",
  "1e30",
  "1e80",
  "1e250",
  "1e1000"
 ],
 [
  "1",
  "5",
  "10",
  "25",
  "75",
  "250",
  "500",
  "1200",
  "4000",
  "10000",
  "25000",
  "100000"
 ],
 [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12"
 ]
] as const

// The internalName column of achievementResources (the UI halves — name,
// shortName — stay in pristine constants.js): the GameState key checked per
// achievement row (achievements.js:227, :240).
export const ACHIEVEMENT_RESOURCE_KEYS = [
 "gold",
 "fire",
 "platinum",
 "magic",
 "magifolds",
 "uranium",
 "cyanSigils",
 "blueSigils",
 "indigoSigils",
 "violetSigils",
 "pinkSigils",
 "knowledge",
 "totalTomes",
 "blueFire",
 "blood",
 "plutonium",
 "redSigils",
 "orangeSigils",
 "yellowSigils",
 "holyTetrahedrons",
 "holyOctahedrons",
 "holyFire",
 "holyDodecahedrons",
 "planets",
 "hypergodsDefeated"
] as const

// State-key prefixes (sigils.js:3, :14; knowledge.js:92-95). Also used as
// display names by the ui — that half stays in pristine constants.js.
export const SIGIL_COLOURS = [ "cyan", "blue", "indigo", "violet", "pink", "red", "orange", "yellow" ] as const

// {base, initialCost} pairs consolidated for engine/formulas.ts upgradeCost().
export const UPGRADE_FAMILIES = {
  fireUpgrade: { base: [0,1.8,2,1.4,1.5,2.5,5], initialCost: [0,50,100,100,500,500,20000000] },
  blueFireUpgrade: { base: [0,1.8,2,2.5,1.8,2.2,2], initialCost: [0,500,1000,50000,50000000,150000000,100000000000] },
  holyFireUpgrade: { base: [0,1.8,2,3,2,2.5,3], initialCost: [0,500,1000,10000,50000,10000000,1e+45] },
  plagueUpgrade: { base: [0,2,2.5,3,5,3], initialCost: [0,25,100,100000,1000000,10000000000000] },
  lightEssenceUpgrade: { base: [0,2,3,3], initialCost: [0,100,600,3000] },
  darkEssenceUpgrade: { base: [0,2,3,3], initialCost: [0,100,1000,10000] },
  deathEssenceUpgrade: { base: [0,2,3,3,2.5,4], initialCost: [0,1000,10000,200000,10000000,1e+40] },
  finalityEssenceUpgrade: { base: [0,2,5,4,4], initialCost: [0,1000,4000,1000000000000000,100000000000000000000] },
} as const
